var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackgroundController, BackgroundPlugin as BasePlugin } from '@syllepsis/plugin-basic';
import React from 'react';
import ReactDOM from 'react-dom';
import { ColorPicker } from '../../component';
var ReactBackgroundController = /** @class */ (function (_super) {
    __extends(ReactBackgroundController, _super);
    function ReactBackgroundController(editor, store) {
        var _this = _super.call(this, editor, store) || this;
        _this.refactorToolbar();
        return _this;
    }
    ReactBackgroundController.prototype.refactorToolbar = function () {
        var _this = this;
        this.toolbar.handler = function () { };
        this.toolbar.getRef = function (btnDOM) {
            if (!btnDOM)
                return;
            var dom = document.createElement('div');
            var extraDom = (React.createElement(ColorPicker, { mountDOM: btnDOM, name: "background", editor: _this.editor, getValue: _this.getValue, getAttrs: _this.getAttrs, defaultColor: _this.defaultColor }));
            btnDOM.appendChild(dom);
            ReactDOM.render(extraDom, dom);
        };
    };
    return ReactBackgroundController;
}(BackgroundController));
var BackgroundPlugin = /** @class */ (function (_super) {
    __extends(BackgroundPlugin, _super);
    function BackgroundPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = ReactBackgroundController;
        return _this;
    }
    return BackgroundPlugin;
}(BasePlugin));
export { BackgroundPlugin };
//# sourceMappingURL=index.js.map